import {Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {
    CheckUserIfExistOutputDto,
    IAddUserToCustomerInputDto,
    UserListDto
} from '@shared/service-proxies/service-proxies';
import {AppComponentBase} from '@shared/common/app-component-base';
import {FieldAgentService} from '@app/webshop/field-agent/shared/services/field-agent.service';

@Component({
    selector: 'addManagerModal',
    templateUrl: './add-manager-modal.component.html',
    styleUrls: ['add-manager-modal.component.less']
})
export class AddManagerModalComponent extends AppComponentBase implements OnInit {

    @Output() onCreate: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('addManagerModal', {static: true}) modal: ModalDirective;

    email: string | undefined = undefined;

    active = false;
    saving = false;
    emailType: any;

    user = {} as IAddUserToCustomerInputDto;

    get isAssignAvailable(): boolean {
        return this.manager !== undefined;
    }

    get isSaveAvailable(): boolean {
        return !!this.user?.name && !!this.user?.surname && !!this.user?.phoneNumber;
    }

    showAssignManagerToCompany = false;
    showCreateNewManager = false;

    showBack = false;
    showContinue = true;

    manager: CheckUserIfExistOutputDto | undefined = undefined;

    get isContinueAvailable(): boolean {
        return this.emailType !== undefined;
    }

    get isCompanyEmailSelected(): boolean {
        return this.emailType === 'companyEmail';
    }

    get isPersonalEmailSelected(): boolean {
        return this.emailType === 'personalEmail';
    }

    get isBackAvailable(): boolean {
        return this.showBack;
    }

    constructor(
        injector: Injector,
        private _fieldAgentService: FieldAgentService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
    }

    show(): void {
        this.active = true;
        this.modal.show();
    }

    onSubmit() {
        if (this.isAssignAvailable) {
            this._fieldAgentService
                .addUserToCustomer$(
                    this.manager.name,
                    this.manager.surname,
                    true,
                    this.manager.emailAddress,
                    undefined
                )
                .subscribe((result) => {
                    this.notify.info(this.l('SavedSuccessfully'));
                    this.onCreate.next(result);
                    this.close();
                });
        } else {
            this._fieldAgentService
                .addUserToCustomer$(
                    this.user.name,
                    this.user.surname,
                    this.isPersonalEmailSelected,
                    this.isPersonalEmailSelected ? this.email : undefined,
                    this.user.phoneNumber
                )
                .subscribe((result) => {
                    this.notify.info(this.l('SavedSuccessfully'));
                    this.onCreate.next(result);
                    this.close();
            });
        }
    }

    close(): void {
        this.active = false;
        this._resetModal();
        this.modal.hide();
    }

    private _resetModal() {
        this.showAssignManagerToCompany = false;
        this.showCreateNewManager = false;
        this.showBack = false;

        this.manager = undefined;
        this.email = undefined;
        this.emailType = undefined;
        this.user = {} as IAddUserToCustomerInputDto;

        this.showContinue = true;
    }

    back() {
       this._resetModal();
    }

    continue() {
        if (this.isCompanyEmailSelected) {
            this.showCreateNewManager = true;
        } else {
            this._fieldAgentService.checkUserIfExist$(this.email)
                .subscribe((result: CheckUserIfExistOutputDto) => {
                    if (result.ifExist) {
                        this.showAssignManagerToCompany = true;
                        this.manager = result;
                    } else {
                        this.showCreateNewManager = true;
                    }
                });
        }

        this.showBack = true;
        this.showContinue = false;
    }

    get isShowSubmit(): boolean {
        return this.showBack;
    }

    get isShowContinue(): boolean {
        return this.showContinue;
    }

    isContinueDisabled(formValid: boolean): boolean {
        if (this.isCompanyEmailSelected) {
            return false;
        }

        return !this.isPersonalEmailSelected || !formValid;
    }

}



